import { Circle } from '@chakra-ui/react';
import React, { MouseEvent } from 'react';
import { getStreamUrl } from '../../service/games';
import { UserProfile } from '../../service/social';
import { TwitchIcon } from '../iconComponents/TwitchIcon';

interface LiveSocialLinksProps {
    profile: UserProfile;
}

/**
 * @param profile The user's profile. This component assumes that this profile has live Twitch stream data
 */
export const LiveSocialLinks: React.FC<LiveSocialLinksProps> = ({ profile }) => {
    const handleOnClick = (e: MouseEvent) => {
        const url = getStreamUrl(profile.twitch_profile?.login);
        if (url) {
            e.preventDefault();
            window.open(url, '_blank');
            return false;
        }
    };

    if (!profile?.twitch_stream) {
        return <></>;
    }

    return (
        <Circle className={'social-link-container'} onClick={handleOnClick}>
            <TwitchIcon />
        </Circle>
    );
};
